import { datadogRum } from '@datadog/browser-rum';
import { useSetAtom } from 'jotai';
import { setAxiosTokenInterceptor } from '../../data/api-config';
import { auth } from '../../data/atoms.auth';
import { useAuth } from '../../auth/AppAuth';

export function useTokenRefresh() {
  const setApiToken = useSetAtom(auth.apiTokenAtom);
  const { getAccessTokenSilently, logout } = useAuth();

  const handleAccessTokenSilently = () =>
    getAccessTokenSilently()
      .then((token) => {
        setAxiosTokenInterceptor(token);
        setApiToken(token);
      })
      .catch((error) => {
        console.error('Token Error', error);
        datadogRum.addError(error, { location: 'useTokenRefresh' });

        logout();
      });

  return {
    handleAccessTokenSilently,
  };
}
